import { Component, inject } from '@angular/core';
import { TitleComponent } from '../../shared/components/title/title.component';
import { SideBarMenuService } from '../../shared/components/side-bar-menu/service/side-bar-menu.service';
import { RouterLink } from '@angular/router';
@Component({
  selector: 'app-home-page',
  imports: [TitleComponent, RouterLink],
  styleUrls: ['./home-page.component.css'],
  templateUrl: './home-page.component.html',
})
export class HomePageComponent {
  menuService = inject(SideBarMenuService);
}
